import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Cocktail } from '../services/cocktailApi.ts';
import { FavoritesService } from '../services/favoritesService.ts';
import './CocktailCard.css';

interface CocktailCardProps {
  cocktail: Cocktail;
  hideCategoryAndAlcoholic?: boolean;
}

const CocktailCard: React.FC<CocktailCardProps> = ({ cocktail, hideCategoryAndAlcoholic = false }) => {
  const [isFavorite, setIsFavorite] = useState(false);

  useEffect(() => {
    setIsFavorite(FavoritesService.isFavorite(cocktail.idDrink));
  }, [cocktail.idDrink]);

  const handleToggleFavorite = (e: React.MouseEvent) => {
    e.preventDefault(); // Prevent navigation to cocktail detail
    e.stopPropagation(); // Prevent event bubbling
    const newFavoriteStatus = FavoritesService.toggleFavorite(cocktail.idDrink);
    setIsFavorite(newFavoriteStatus);
  };

  return (
    <div className="cocktail-card">
      <div className="cocktail-image-container">
        <Link to={`/cocktail/${cocktail.idDrink}`} className="cocktail-image-link">
          <img
            src={cocktail.strDrinkThumb}
            alt={cocktail.strDrink}
            className="cocktail-image"
          />
        </Link>
        <button
          onClick={handleToggleFavorite}
          className={`favorite-heart ${isFavorite ? 'favorited' : ''}`}
          title={isFavorite ? 'Remove from favorites' : 'Add to favorites'}
        >
          {isFavorite ? '❤️' : '🤍'}
        </button>
      </div>
      <div className="cocktail-info">
        <h3 className="cocktail-name">{cocktail.strDrink}</h3>
        {!hideCategoryAndAlcoholic && cocktail.strCategory && (
          <p className="cocktail-category">{cocktail.strCategory}</p>
        )}
        {!hideCategoryAndAlcoholic && cocktail.strAlcoholic && (
          <p className="cocktail-alcoholic">{cocktail.strAlcoholic}</p>
        )}
        <Link to={`/cocktail/${cocktail.idDrink}`} className="view-recipe-btn">
          View Recipe
        </Link>
      </div>
    </div>
  );
};

export default CocktailCard;
